import React, { useState, useEffect } from 'react';
import axios from 'axios';

const QnaList = () => {
  const [qnaList, setQnaList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // API 호출
    axios.get('/api/qna')
      .then(response => {
        setQnaList(response.data.data);
        setLoading(false);
      })
      .catch(err => {
        console.error("데이터 로드 실패:", err);
        setError("문의 내역을 불러오는 중 오류가 발생했습니다.");
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="text-center mt-5">로딩 중...</div>;
  if (error) return <div className="text-center mt-5 text-danger">{error}</div>;

  return (
    <div className="container my-2 px-0" style={{ maxWidth: '600px', paddingTop: '20px' }}>
      <h2 className="mb-3 mx-3">나의 문의내역</h2>

      {qnaList.length === 0 ? (
        <div
        className="alert text-secondary mx-2"
        style={{ background: '#f1f3f5', fontSize: '13px' }}
        >
        문의 내역이 없습니다.
        </div>
      ) : (
        qnaList.map((row) => (
          <div key={row.id} className="qna-card shadow-sm mb-4" style={styles.qnaCard}>
            {/* 헤더 섹션 */}
            <div className="d-flex justify-content-between align-items-center mb-3 pb-3 border-bottom">
              <div className="d-flex align-items-center">
                {row.image_path && (
                  <img 
                    src={row.image_path.startsWith('http') ? row.image_path : `/static/${row.image_path}`} 
                    alt="상품 이미지" 
                    className="me-3" 
                    width="60" 
                    style={{ borderRadius: '4px' }}
                  />
                )}
                <strong style={{ fontSize: '1.1rem' }}>{row.product_name}</strong>
              </div>
              <div>
                <a href={`/product/${row.product_id}`} className="text-muted text-decoration-none" style={{ fontSize: '0.85rem' }}>
                  제품보기
                </a>
              </div>
            </div>

            {/* 문의 내용 */}
            <div className="mb-3 pb-3 border-bottom" style={styles.qnaContent}>
              <div className="mb-1">
                <strong>문의</strong> 
                <span className="ms-2 text-muted" style={{ fontSize: '0.75rem' }}>
                  ({row.created_at})
                </span>
              </div>
              <div dangerouslySetInnerHTML={{ __html: row.question?.replace(/\n/g, '<br>') }} />
            </div>

            {/* 답변 내용 */}
            <div style={styles.qnaContent}>
              <div className="mb-1">
                <strong>답변</strong>
                {row.answered_at && (
                  <span className="ms-2 text-muted" style={{ fontSize: '0.75rem' }}>
                    ({row.answered_at})
                  </span>
                )}
              </div>
              {row.answer ? (
                <div dangerouslySetInnerHTML={{ __html: row.answer.replace(/\n/g, '<br>') }} />
              ) : (
                <span className="text-muted">답변 대기중</span>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

// 인라인 스타일 객체 (기존 CSS 유지)
const styles = {
  qnaCard: {
    background: 'white',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    marginBottom: '28px',
    padding: '20px'
  },
  qnaContent: {
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    lineHeight: '1.5',
    color: '#444',
    fontSize: '0.9rem',
    textAlign: 'left',
  }
};

export default QnaList;